import {TorchUser} from './torch-user.model';

export class Feedback {
  id: number;
  type: string;
  submittedBy: TorchUser;
  submittedOn: Date;
  url: string;
  screenshot: string;
  description: string;
  title: string;
  workItemCreated = false;
  workItemID: number;
  logs: string;

  static createWithUser(user: TorchUser): Feedback {
    const newFeedback = new Feedback();

    newFeedback.submittedBy = user;
    newFeedback.submittedOn = new Date();
    newFeedback.url = window.location.href;

    return newFeedback;
  }
}
